import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type SummaryImpressionEventParams = {
	node: Element;
	eventName: string;
	componentName: string;
	elementName?: string;
	clickID?: boolean;
	relatedElements?: { elementName: string; elementValue: string }[];
};

export class SummaryImpressionEvent extends BaseEvent {
	constructor({ eventName, componentName, clickID, relatedElements }: SummaryImpressionEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Impression,
				eventName,
			},
			attributes: {
				componentName,
				clickID: `${clickID}`,
				...(relatedElements && { relatedElements }),
			},
		});
	}
}
